import React from 'react'
import styled from 'styled-components'
import { Box } from 'styling/GlobalStyles'

export const CardHeader = styled.div<{ padding?: string }>`
  width: 100%;
  ${(props) => props.theme.container};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: ${(props) => props.padding || 'var(--card-padding)'};
`

export const CardBody = styled.div<{ padding?: string }>`
  width: 100%;
  padding: ${(props) => props.padding || 'var(--card-padding)'};
`

export const StyckyFooter = styled.div`
  margin-top: 1rem;
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: var(--card-padding);
  z-index: 100;
  display: flex;
  justify-content: flex-end;
`

export const CardFooter = ({ children }: { children: React.ReactNode }) => {
  return <Box>{children}</Box>
}

export const Card = styled.div<{
  padding?: string
  borderLeft?: string
  height?: string
  mt?: string
  onClick?: () => void
  fullBorder?: string
  hoverBorder?: boolean
  noScale?: boolean
}>`
  width: 100%;
  ${(props) => props.theme.container};
  color: ${(props) => props.theme.textColor};

  --card-padding: ${(props) => props.padding || '1rem'};
  border-left: ${(props) => (props.borderLeft ? `4px solid ${props.borderLeft}` : 'none')};
  height: ${(props) => props.height || 'auto'};
  margin-top: ${(props) => props.mt || '0'};
  position: relative;
  ${(props) => props.onClick && 'cursor: pointer;'};
  ${(props) => props.onClick && 'transition: all 0.2s ease;'};
  ${(props) => props.fullBorder && 'border: 1px solid ' + props.fullBorder};
  ${(props) => props.onClick && !props.noScale && '&:hover { scale: 1.01;}'};
  ${(props) =>
    !props.fullBorder &&
    props.hoverBorder &&
    'border: 1px solid ' + props.theme.colorNeutrals700 + ';'};
  ${(props) => props.hoverBorder && '&:hover { border: 1px solid ' + props.theme.colorOrange + ';'};
`
